import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Slide } from '../slider/models/slider.model';

const MAIN_PAGE_ENDPOINT = '/homepage';

@Injectable()
export class MainPageService {
  constructor() { }

  // todo delete magic ids when real cms will be up and running
  getSlides(): Slide[] {
    return [
      {
        buttonLabel: 'Czytaj dalej',
        description: '',
        destination: {
          id: null,
          type: 'new_regulations_for_25t_2026_article'
        },
        header: '<span class="header-red">UWAGA</span>',
        href: null,
        id: 201,
        img: 'assets/images/sliders/25t-regulation.jpg',
        ordinalNumber: 1,
        subheader: 'Transport międzynarodowy: obowiązek rejestracji czasu pracy kierowców pojazdów od 2,4 do 3,5 tony już od 1 lipca 2026!<br/>Zamów kartę kierowcy już teraz, nie czekaj na ostatni moment.',
        alt: 'IMAGES.alt.slider25tRegulation'
      },
      {
        buttonLabel: 'Przejdź do info-kierowca.pl',
        description: '',
        destination: null,
        header:
          '<span>UWAGA</span>',
        href: 'https://info-kierowca.pl',
        id: 202,
        img: 'assets/images/sliders/info-kierowca.png',
        ordinalNumber: 2,
        subheader: 'REZERWACJE EGZAMINU W NOWYM MIEJSCU. <br/>WEJDŹ NA INFO-KIEROWCA.PL',
        alt: 'IMAGES.alt.sliderInfoKierowca'
      },
      {
        buttonLabel: 'Czytaj dalej',
        description: '',
        destination: {
          id: null,
          type: 'new_stc_applications_2026_article'
        },
        header:
          '<span class="header-red">UWAGA</span>',
        href: null,
        id: 203,
        img: 'assets/images/sliders/new_tacho_info.jpg',
        ordinalNumber: 3,
        subheader: 'Nowe wzory wniosków o karty do tachografów',
        alt: 'IMAGES.alt.sliderNewTachoInfo'
      },
      {
        buttonLabel: null,
        description: '',
        destination: null,
        header: '<span class="header-red">UWAGA</span><br/>ZMIANA REGULAMINU SERWISU INFOCAR<br/>WYGASZAMY USŁUGI PŁATNOŚCI ZA DOKUMENTY',
        href: null,
        id: 204,
        img: 'assets/images/sliders/AS.jpg',
        ordinalNumber: 4,
        subheader: '',
        alt: 'IMAGES.alt.sliderServiceNotice'
      },
      {
        buttonLabel: 'Czytaj dalej',
        description: '',
        destination: {
          id: null,
          type: 'g2v2_info_article'
        },
        header:
          'NOWE KARTY TACHOGRAFOWE G2V2',
        href: null,
        id: 206,
        img: 'assets/images/sliders/g2v2_banner.png',
        ordinalNumber: 5,
        subheader:
          'SPRAWDŹ, CO SIĘ ZMIENIŁO!',
        alt: 'IMAGES.alt.sliderG2v2'
      },
      {
        buttonLabel: 'Czytaj dalej',
        description: '',
        destination: {
          id: null,
          type: 'word_price_article'
        },
        header:
          'Ceny egzaminów idą w górę',
        href: null,
        id: 208,
        img: 'assets/images/sliders/slider_egzaminy_ceny.png',
        ordinalNumber: 6,
        subheader:
          'kolejne sejmiki wojewódzkie zmieniają stawki',
        alt: 'IMAGES.alt.sliderExamPrices'
      },
      {
        buttonLabel: 'Dowiedz się więcej',
        description: '',
        destination: { id: null, type: 'duedate_article' },
        header: '<span class=\'header-red\'>COVID-19</span> PRZEDŁUŻENIE WAŻNOŚCI DOKUMENTÓW',
        href: null,
        id: 211,
        img: 'assets/images/sliders/waznosc.jpg',
        ordinalNumber: 7,
        subheader:
          'Wszystkie te dokumenty i uprawnienia, których termin upłynął w okresie stanu zagrożenia epidemicznego lub stanu epidemii pozostaną ważne i będą ważne także w okresie 60 dni od daty zakończenia stanu zagrożenia epidemicznego lub stanu epidemii.',
        alt: 'IMAGES.alt.sliderValidity'
      },
      {
        buttonLabel: 'Dowiedz się więcej',
        description: '',
        destination: { id: null, type: 'applications_article' },
        header: '<span class="header-red">UWAGA</span>',
        href: null,
        id: 212,
        img: 'assets/images/sliders/tacho.jpg',
        ordinalNumber: 8,
        subheader:
          'OD 4 MAJA 2020 R. PWPW BĘDZIE <br>PRZYJMOWAŁA WNIOSKI JEDYNIE NA <br>AKTUALNIE OBOWIĄZUJĄCYCH <br>FORMULARZACH.',
        alt: 'IMAGES.alt.sliderTachoApplication'
      },
      {
        buttonLabel: 'Dowiedz się więcej',
        description: '',
        destination: null,
        header: 'Potrzebujesz podpisu kwalifikowanego?',
        href: 'https://sigillum.pl/',
        id: 213,
        img: 'assets/images/sliders/sigillum.jpg',
        ordinalNumber: 9,
        subheader:
          'Sprawdź ofertę centrum usług zaufania sigillum <br>teraz dostępny również "Podpis kwalifikowany na e-dowodzie"',
        alt: 'IMAGES.alt.sliderSigillum'
      },
      {
        id: 221,
        header: "CZEKASZ NA DOWÓD REJESTRACYJNY?",
        subheader: "SPRAWDŹ CZY TWÓJ DOWÓD REJESTRACYJNY JEST GOTOWY DO ODBIORU",
        description: "",
        buttonLabel: "Więcej",
        img: "assets/images/sliders/driver-license.jpg",
        ordinalNumber: 10,
        href: null,
        destination: {
          id: null,
          type: 'check_registration_document_status'
        },
        alt: 'IMAGES.alt.sliderDriverLicense'
      },
      {
        id: 223,
        header: "ADR ZASADY ZDOBYWANIA ZAŚWIADCZENIA",
        subheader: "SPRAWDŻ, JAK ZDOBYĆ ZAŚWIADCZENIA ADR",
        description: "",
        buttonLabel: "Więcej",
        img: "assets/images/sliders/adr.jpg",
        ordinalNumber: 11,
        href: null,
        destination: {
          id: null,
          type: 'adr_certificate_rules'
        },
        alt: 'IMAGES.alt.sliderAdr'
      },
      {
        id: 224,
        header: "JESTEŚ KIEROWCĄ ZAWODOWYM?",
        subheader: "UZYSKAJ KARTĘ DO TACHOGRAFU",
        description: "",
        buttonLabel: "Uzyskaj kartę",
        img: "assets/images/sliders/driver-tacho.jpg",
        ordinalNumber: 12,
        href: null,
        destination: {
          id: null,
          type: 'tachograph_card'
        },
        alt: 'IMAGES.alt.sliderDriverTacho'
      }
    ];
  }
}
